export interface IAttendance {
  locationName: string;
  customerName: string;
  eventName: string;
  eventType: string;
  providerName: string;
  checkInTime: Date;
  checkInStatus: string;
  active?: boolean;
  bookingState?: string;
  pendingBookingId: string | null;
  error?: string;
}

export const AttendanceStatus: IAttendanceStatus = {
  CheckedIn: 'Checked-in',
  LateCancellation: 'Late cancellation',
  NoShow: 'No show',
  Pending: 'Processing',
};

export const AttendanceStatusType: IAttendanceStatus = {
  CheckedIn: 'success',
  LateCancellation: 'warning',
  NoShow: 'danger',
  Pending: 'info',
};

export interface IAttendanceStatus {
  [key: string]: any;
}
